export let initialState = {
  accountSettings: false
}

export const updateSettings = (account) => (updatedSettings) => {
  account.setState({ accountSettings: updatedSettings })
}
